<template>
  <div class="stat-index-page">
    <tiles-page
      title="Статистика"
      :link-groups="linksGroups"
      sm="4"
    />
    <tiles-page
      v-if="isSuperAdmin"
      title="Колл-центр"
      title-tag="h2"
      :link-groups="callCenterLinksGroups"
      sm="4"
    />
    <call-center-charts-view v-if="showCallCenterCharts" class="mt-5" />
  </div>
</template>

<script>
  import TilesPage from '@/components/ui/TilesPage.vue'
  import {
    mainLinksGroups,
    callCenterLinksGroups,
  } from '@/pages/Stat/linksGroups'
  import permissions from '@/mixins/permissions'
  import Role from '@/models/enums/Roles'
  import CallCenterChartsView from '@/components/stat/call-center/CallCenterChartsView.vue'

  export default {
    name: 'StatIndex',
    components: {
      CallCenterChartsView,
      TilesPage,
    },
    mixins: [permissions],
    computed: {
      linksGroups () {
        if (this.isSuperAdmin) {
          return mainLinksGroups
        }

        return this.userIs([Role.CallCentreDirector, Role.CallCentreOperator])
          ? callCenterLinksGroups
          : mainLinksGroups
      },
      callCenterLinksGroups () {
        return callCenterLinksGroups
      },
      showCallCenterCharts () {
        if (this.isSuperAdmin) {
          return true
        }

        return this.userIs([Role.CallCentreDirector, Role.CallCentreOperator])
      },
    },
  }
</script>
